export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-20 pb-12 md:pb-0 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="w-full flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs md:text-sm font-medium mb-5">
              <i className="ri-fire-line text-accent-600"></i>
              <span>每日更新 · 海量片源</span>
            </div>

            <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
              番茄影视大全
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-600 mt-2">
                免费高清在线观影平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-4">
              番茄影视大全聚合海量高清影视资源，覆盖热播电视剧、院线大片、人气综艺、经典动漫等全品类内容。无需注册、不花一分钱，打开即可畅享高清不缓冲的观影体验。平台每日同步更新最新剧集，追剧不等待，全网热播一站收录。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              当前热门：《藏海花》《长相思 第二季》《唐朝诡事录之西行》等高分剧集正在热播中，更有《飞驰人生2》《热辣滚烫》等院线新片全网首发上线。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">30万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源收录</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-600 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">全网热剧同步</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">高清不缓冲</div>
                <div className="text-xs text-foreground-500 mt-1">极速播放体验</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-play-circle-line text-lg"></i>
                查看热播榜单
              </a>
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 font-medium text-sm md:text-base hover:bg-background-100 hover:border-foreground-300 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索内容分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20film%20reel%20elements%2C%20spotlight%20effects%2C%20soft%20theater%20lighting%2C%20classic%20cinema%20aesthetic%2C%20film%20strip%20borders%2C%20dramatic%20atmosphere%2C%20elegant%20movie%20poster%20style%20composition%2C%20warm%20texture%20overlay%2C%20vintage%20theater%20vibe%2C%20no%20text&width=800&height=1000&seq=hero-main-2026&orientation=portrait"
                  alt="番茄影视大全 - 海量高清影视免费在线观看"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 w-24 h-24 md:w-32 md:h-32 rounded-2xl overflow-hidden border-4 border-background-50 bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20soft%20bokeh%20lights%2C%20film%20grain%20texture%2C%20golden%20and%20amber%20color%20palette%2C%20movie%20theater%20ambiance%2C%20dreamy%20atmosphere%2C%20artistic%20blur%20effect%2C%20cozy%20viewing%20experience%20vibe&width=400&height=400&seq=hero-sub-2026&orientation=squarish"
                  alt="高清流畅的观影体验"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}